import dayjs from 'dayjs'
import { useId } from 'react'

import { useGetFilterValue } from '@/legacy-src/components/filters/hooks/useGetFilterValue'
import { useSetFilters } from '@/legacy-src/components/filters/hooks/useSetFilters'
import { IN_DAYS_COUNT_VALUE_LABEL_MAP } from '@/legacy-src/components/filters/timeFilters/constants'
import { useDebouncedState } from '@/legacy-src/hooks/useDebouncedState'
import { formatDateWithDayName } from '@/legacy-src/utilities/date'
import { getTranslate } from '@/legacy-src/utilities/i18n'
import { solveNewValue } from '@/legacy-src/utilities/reduxHelpers'

import { Checkbox } from '@/src/domains/design-system/components/Checkbox'
import { Label } from '@/src/domains/design-system/components/Label'

const TimeInXDays: React.FC = () => {
  const { t } = getTranslate()

  const initialValue = useGetFilterValue('availability')
  const setFilters = useSetFilters()

  const { value, onChange } = useDebouncedState({
    value: initialValue,
    wait: 1000,
    callback: (newValue) => {
      setFilters([
        { slug: 'availability', value: newValue },
        { slug: 'times', value: [] },
        { slug: 'days', value: [] },
      ])
    },
  })

  const handleChange = (v: string) => {
    onChange(solveNewValue(value, v))
  }

  const id = useId()

  return (
    <div>
      {Object.entries(IN_DAYS_COUNT_VALUE_LABEL_MAP).map(([item, label]) => (
        <div className="mb-5 flex items-center gap-3 last:mb-0" key={item}>
          <Checkbox id={`${id}-${item}`} checked={value.includes(item)} onCheckedChange={() => handleChange(item)} />
          <Label variant="selection-control" className="grow" htmlFor={`${id}-${item}`}>
            {t(label)} ({formatDateWithDayName(dayjs().add(Number(item), 'day'))})
          </Label>
        </div>
      ))}
    </div>
  )
}

export default TimeInXDays
